/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateDiscreteNumericListDtoGeometry } from './CreateDiscreteNumericListDtoGeometry';
import {
    CreateDiscreteNumericListDtoGeometryFromJSON,
    CreateDiscreteNumericListDtoGeometryFromJSONTyped,
    CreateDiscreteNumericListDtoGeometryToJSON,
} from './CreateDiscreteNumericListDtoGeometry';

/**
 * 
 * @export
 * @interface CreateNumericValueDto
 */
export interface CreateNumericValueDto {
    /**
     * 
     * @type {string}
     * @memberof CreateNumericValueDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateNumericValueDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateNumericValueDto
     */
    isRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateNumericValueDto
     */
    isReadonly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateNumericValueDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateNumericValueDto
     */
    numericId?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateNumericValueDto
     */
    value?: number | null;
    /**
     * 
     * @type {CreateDiscreteNumericListDtoGeometry}
     * @memberof CreateNumericValueDto
     */
    geometry?: CreateDiscreteNumericListDtoGeometry | null;
    /**
     * 
     * @type {string}
     * @memberof CreateNumericValueDto
     */
    $type?: CreateNumericValueDtoTypeEnum;
}


/**
 * @export
 */
export const CreateNumericValueDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoCreateNumericValueDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.CreateNumericValueDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateNumericValueDtoTypeEnum = typeof CreateNumericValueDtoTypeEnum[keyof typeof CreateNumericValueDtoTypeEnum];


/**
 * Check if a given object implements the CreateNumericValueDto interface.
 */
export function instanceOfCreateNumericValueDto(value?: unknown): value is CreateNumericValueDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateNumericValueDtoTypeEnum)[0];
}

export function CreateNumericValueDtoFromJSON(json: any): CreateNumericValueDto {
    return CreateNumericValueDtoFromJSONTyped(json, false);
}

export function CreateNumericValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateNumericValueDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dataTypeId': !exists(json, 'dataTypeId') ? undefined : json['dataTypeId'],
        'isRequired': !exists(json, 'isRequired') ? undefined : json['isRequired'],
        'isReadonly': !exists(json, 'isReadonly') ? undefined : json['isReadonly'],
        'isEnabled': !exists(json, 'isEnabled') ? undefined : json['isEnabled'],
        'numericId': !exists(json, 'numericId') ? undefined : json['numericId'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'geometry': !exists(json, 'geometry') ? undefined : CreateDiscreteNumericListDtoGeometryFromJSON(json['geometry']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CreateNumericValueDtoToJSON(value?: CreateNumericValueDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'dataTypeId': value.dataTypeId,
        'isRequired': value.isRequired,
        'isReadonly': value.isReadonly,
        'isEnabled': value.isEnabled,
        'numericId': value.numericId,
        'value': value.value,
        'geometry': CreateDiscreteNumericListDtoGeometryToJSON(value.geometry),
        '$type': value.$type,
    });
}

